import React from 'react';
import { Edit3 } from 'lucide-react';

interface EditPromptButtonProps {
  onEdit: () => void;
}

/**
 * Edit button for user prompts
 * Shows when prompt is editable (stopped before EOP or reached EOP with no next prompt)
 */
export const EditPromptButton: React.FC<EditPromptButtonProps> = ({ onEdit }) => {
  return (
    <button
      onClick={onEdit}
      className="flex items-center gap-1 cursor-pointer hover:opacity-80 transition-opacity text-muted-foreground hover:text-foreground"
      title="edit this prompt"
    >
      <Edit3 className="w-3 h-3" />
      <span className="text-xs">edit</span>
    </button>
  );
};

